export const getAccessToken = (state) => state.OpenBankingReducer.accessToken;